import { apiClient } from './apiClient';

export type MagicLinkResponse = {
  id: string;
  url: string;
  expiresAt: string;
  status: string;
  recipientEmail: string;
  maxUses: number;
};

const API_V1 = '/api/v1';

export const magicLinkService = {
  getByConciergeId(conciergeId: string) {
    return apiClient.getJson<MagicLinkResponse>(`${API_V1}/magic-link/concierge/${conciergeId}`);
  },
};
